// extracted by mini-css-extract-plugin
export var exit = "_2-3";
export var notificationContainer = "_2-1";
export var notificationStack = "_2-0";
export var shrinkFadeOut = "_2-4";
export var slideInUp = "_2-2";